import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, UserService, ModalService, ModalContainerService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { MesnaZajednica } from './mesna-zajednica';

@Component({
  selector: 'yt-mesna-zajednica',
  templateUrl: './mesna-zajednica.component.html'  
})
export class MesnaZajednicaComponent extends BaseModalContainer<MesnaZajednica> implements OnInit {

  constructor (
    protected modalContainerService: ModalContainerService<MesnaZajednica>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
){
    super(modalContainerService, activatedRoute, modalService, userService)
}
  ngOnInit() {
  }

}
